module.exports = __webpack_public_path__ + "static/media/uploadAndSubmit.9b90ef10.png";